import { createPermission } from "@backstage/plugin-permission-common";

export const cloudhealthExplorerReadPermission = createPermission({
  name: "cloudhealth-explorer.read",
  attributes: {
    action: "read",
  },
});

export const cloudhealthExplorerWritePermission = createPermission({
  name: "cloudhealth-explorer.write",
  attributes: {
    action: "update",
  },
});

export const cloudhealthExplorerPermissions = [
  cloudhealthExplorerReadPermission,
  cloudhealthExplorerWritePermission,
];
